import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function FooterSection() {
  return (
    <footer className="max-w-5xl mx-auto px-4 py-16 sm:py-24 text-center">
      <h2 className="text-2xl font-medium text-foreground mb-3">
        Ready to let AI run your marketing?
      </h2>
      <p className="text-sm text-muted-foreground mb-6">
        Free forever for solo users. Pro starts at ฿299/month.
      </p>

      <Button asChild size="lg" className="rounded-lg px-8">
        <Link to="/signup">Get started free</Link>
      </Button>

      <div className="flex justify-center gap-4 mt-12 mb-4 text-sm text-muted-foreground">
        <a href="#" className="hover:text-foreground transition-colors">Privacy</a>
        <a href="#" className="hover:text-foreground transition-colors">Terms</a>
      </div>

      <p className="text-xs text-muted-foreground pb-8">
        Powered by Scaliq — AI-native marketing for Thai SMEs
      </p>
    </footer>
  );
}
